if (!customElements.get("section-discover-scanner")) {
  customElements.define(
    "section-discover-scanner",
    class SectionDiscoverScanner extends HTMLElement {
      constructor() {
        super();
        this.outWrapper = $(".section-discover-scanner-wrapper");
        this.outCardItems = $(
          ".section-discover-scanner-wrapper .ds-card-item"
        );
        this.innerContent = $(".inner-wrapper");
        this.innerBtnBack = $(".inner-btn-back");

        this.init();
      }
      init() {
        var _that = this;
        // var durationTime = 100
        this.outCardItems.each(function () {
          $(this).on("click", function () {
            var index = $(this).index();
            _that.outWrapper.hide();
            _that.innerContent.hide();
            _that.innerContent.eq(index).show();
          });
        });

        this.innerBtnBack.on("click", function () {
          _that.innerContent.hide();
          _that.outWrapper.show();
        });
      }
    }
  );
}
